/* Ordinia v13 · movimiento y pequeños comportamientos. Sin librerías.
   - Revelado al entrar en pantalla ([data-ord13-reveal], [data-ord13-cap]).
   - Manifiesto: palabras que se iluminan con el progreso de scroll (1:1 con el dedo).
   - Carrusel de razones: flechas que avanzan una tarjeta; scroll nativo con imán.
   - Cabecera: sombra fina solo cuando hay contenido debajo. */
(function () {
  var root = document.documentElement;
  root.classList.add('ord13-js');

  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-ord13-reveal]:not(.is-in), [data-ord13-cap]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initWords() {
    var blocks = document.querySelectorAll('[data-ord13-words]');
    if (!blocks.length) return;
    var items = [];
    blocks.forEach(function (el) {
      if (el.dataset.ord13Split) return;
      el.dataset.ord13Split = '1';
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'w';
        s.textContent = w;
        el.appendChild(s);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
      items.push({ el: el, words: el.querySelectorAll('.w') });
    });
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      items.forEach(function (it) {
        var r = it.el.getBoundingClientRect();
        // 0 cuando el bloque asoma por abajo (85 % de la pantalla), 1 cuando su final pasa el 40 %
        var start = vh * 0.85, end = vh * 0.4;
        var p = (start - r.top) / (start - end + r.height);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * it.words.length);
        for (var i = 0; i < it.words.length; i++) it.words[i].classList.toggle('on', i < n);
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initCarousels() {
    document.querySelectorAll('[data-ord13-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-ord13-track]');
      if (!track) return;
      var prev = c.querySelector('[data-dir="-1"]'), next = c.querySelector('[data-dir="1"]');
      function step() {
        var card = track.firstElementChild;
        return card ? card.getBoundingClientRect().width + 20 : 320;
      }
      function sync() {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      [prev, next].forEach(function (b) {
        if (!b) return;
        b.addEventListener('click', function () {
          track.scrollBy({ left: step() * Number(b.dataset.dir), behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }

  function initHeader() {
    var on = false;
    function check() {
      var s = window.scrollY > 4;
      if (s !== on) { on = s; root.classList.toggle('ord13-scrolled', s); }
    }
    window.addEventListener('scroll', check, { passive: true });
    check();
  }


  /* Selector de variantes al estilo Apple Store: titular «Opción. Pregunta.», tarjetas con precio
     por opción (y precio por unidad en los packs) y muestras de color redondas con el nombre elegido.
     Horizon vuelve a pintar el selector al cambiar de variante: un observador lo repasa cada vez. */
  var O13_EN = /^en/i.test(document.documentElement.lang || '');
  var O13_SUB = O13_EN
    ? { color: 'Choose yours.', colour: 'Choose yours.', pack: 'How many do you need?', model: 'Choose yours.', size: 'By age.', age: 'By age.' }
    : { color: 'Elige el tuyo.', pack: '¿Cuántas necesitas?', modelo: 'Elige el tuyo.', talla: 'Según la edad.' };
  var O13_SW = { gris: '#8e8e93', blanco: '#f5f5f7', white: '#f5f5f7', negro: '#1d1d1f', black: '#1d1d1f', rosa: '#f2b8c6', pink: '#f2b8c6', verde: '#9fd3a9', green: '#9fd3a9', azul: '#9cc3e6', blue: '#9cc3e6', grey: '#8e8e93', gray: '#8e8e93',
    multicolor: 'conic-gradient(#f2b8c6, #9cc3e6, #9fd3a9, #f7d774, #f2b8c6)' };
  function money(c) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    if (cur === 'EUR') return (c / 100).toFixed(2).replace('.', ',') + ' €';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: cur }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + cur; }
  }
  function variantsData() {
    var el = document.getElementById('o13-variants');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function enhanceVariants() {
    var data = variantsData();
    document.querySelectorAll('fieldset.variant-option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (!legend) return;
      if (!legend.dataset.o13) {
        var name = legend.textContent.trim();
        legend.dataset.o13 = name;
        var sub = O13_SUB[name.toLowerCase()];
        legend.innerHTML = '<span class="o13-legend__name">' + name + '.</span>' + (sub ? ' <span class="o13-legend__sub">' + sub + '</span>' : '');
      }
      var isColor = /color/i.test(legend.dataset.o13);
      fs.classList.add(isColor ? 'o13-swatches' : 'o13-tiles');
      // Como en Apple: el precio solo aparece en cada opción si cambia entre opciones
      var samePrice = true;
      if (!isColor && data) {
        var seen = null;
        fs.querySelectorAll('input[data-variant-id]').forEach(function (inp) {
          var vv = data.variants.find(function (x) { return String(x.id) === String(inp.dataset.variantId); });
          if (!vv) return;
          if (seen === null) seen = vv.price; else if (vv.price !== seen) samePrice = false;
        });
      }
      fs.querySelectorAll('label.variant-option__button-label').forEach(function (lab) {
        var input = lab.querySelector('input');
        if (!input) return;
        if (isColor) {
          var key = (input.value || '').toLowerCase().split(' ')[0];
          if (O13_SW[key]) lab.style.setProperty('--o13-sw', O13_SW[key]);
          return;
        }
        if (!data || samePrice || lab.querySelector('.o13-vprice')) return;
        var v = data.variants.find(function (x) { return String(x.id) === String(input.dataset.variantId); });
        if (!v) return;
        var txt = money(v.price);
        var n = parseInt((input.value.match(/(\d+)\s*(?:ud|pcs|pieces|units?)/i) || [])[1], 10);
        if (n > 1) txt += '<small>' + money(Math.round(v.price / n)) + (O13_EN ? ' / unit' : ' / ud') + '</small>';
        var sp = document.createElement('span');
        sp.className = 'o13-vprice';
        sp.innerHTML = txt;
        lab.appendChild(sp);
      });
      if (isColor) {
        var checked = fs.querySelector('input:checked');
        var cap = fs.querySelector('.o13-swname');
        if (!cap) { cap = document.createElement('p'); cap.className = 'o13-swname'; fs.appendChild(cap); }
        var val = checked ? checked.value : '';
        if (cap.textContent !== val) cap.textContent = val;
      }
    });
  }
  function initVariants() {
    if (!document.getElementById('o13-variants')) return;
    enhanceVariants();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; enhanceVariants(); initAmbient(); });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) requestAnimationFrame(enhanceVariants); });
  }

  /* Galería de la ficha: si la foto no es cuadrada, su versión pequeña y desenfocada rellena el marco
     (el CSS la pinta en ::before con --o13-amb). */
  function initAmbient() {
    document.querySelectorAll('.product-information__media .product-media:not(.o13-amb)').forEach(function (pm) {
      var ratio = parseFloat(pm.style.getPropertyValue('--ratio'));
      var img = pm.querySelector('img');
      if (!img || !ratio || Math.abs(ratio - 1) < 0.04) return;
      var src = (img.currentSrc || img.src || '').replace(/([?&])width=\d+/, '$1width=160');
      if (!src) return;
      pm.style.setProperty('--o13-amb', 'url("' + src + '")');
      pm.classList.add('o13-amb');
    });
  }

  // En acción: cada vídeo se carga la primera vez que asoma y solo se reproduce mientras se ve
  function initAccion(scope) {
    var vids = (scope || document).querySelectorAll('video[data-ord13-video]:not([data-ord13-ok])');
    if (!vids.length) return;
    // Reloj común: todos los vídeos van en la misma fase del bucle, entren cuando entren
    function sync(v) {
      var d = v.duration;
      if (d && isFinite(d)) { try { v.currentTime = (performance.now() / 1000) % d; } catch (_) {} }
    }
    function play(v) {
      if (!v.src && v.dataset.src) v.src = v.dataset.src;
      if (v.readyState >= 1) sync(v);
      else v.addEventListener('loadedmetadata', function () { sync(v); }, { once: true });
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { vids.forEach(play); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) play(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { rootMargin: '0px 200px', threshold: 0.35 });
    vids.forEach(function (v) { v.dataset.ord13Ok = '1'; io.observe(v); });
  }

  function init() {
    initReveal();
    initWords();
    initCarousels();
    initAccion();
    initHeader();
    initVariants();
    initAmbient();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: re-inicializar al añadir o cambiar secciones
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initWords(); initCarousels(); initAccion(e.target);
  });
})();
